import { create } from "zustand";

import sendRequest from "./send-request";

import useAppStore from "./useAppStore";

const API_URL_SHOP = "https://nightdrinkas.onrender.com/api/shop/";
const API_URL_CART = `https://nightdrinkas.onrender.com/api/shop/cart/`;
const API_URL_ADMIN = "https://nightdrinkas.onrender.com/api/admin/";

// const API_URL_SHOP = "http://localhost:8000/api/shop/";
// const API_URL_CART = "http://localhost:8000/api/shop/cart/";
// const API_URL_ADMIN = "http://localhost:8000/api/admin/";

const initialState = {
  products: null,
  product: null,
  wine: null,
  beer: null,
  spirits: null,

  cart: {
    products: [],
    totalPrice: 0,
    totalQty: 0,
  },
  success: null,
};
// const { loading } = useAppStore((state) => state);
const store = (set, get) => ({
  ...initialState,
  shopResetAll: () => set({ ...initialState }),

  /* 
  GET--->
  Gets all the Procducts no need for paramer its returns in same way
  as products are saved in database.
  */
  getProducts: async () => {
    try {
      const response = await sendRequest({
        url: `${API_URL_SHOP}products`,
      });
      set({ products: response.data.data });
      useAppStore.setState({
        success: true,
      });
    } catch (error) {
      useAppStore.setState({
        errors: {
          errorName: error.errorName,
          message: error.message,
          errorCode: error.errorCode,
        },
        success: false,
      });
    }
  },

  /*  
  GET--->
  gets one Single Procuct 
  */
  getProduct: async (id) => {
    try {
      const response = await sendRequest({
        url: `${API_URL_SHOP}products/${id}`,
      });
      set({ product: response.data.data });
      useAppStore.setState({
        success: true,
        products: true,
      });
    } catch (error) {
      useAppStore.setState({
        errors: {
          errorName: error.errorName,
          message: error.message,
          errorCode: error.errorCode,
        },
        success: false,
        products: true,
      });
    }
  },
  /*  
  GET--->
  gets by AnyCategory which comes as Parameter 
  */
  getByCategory: async (category) => {
    try {
      const response = await sendRequest({
        url: `${API_URL_SHOP}products/?category=${category}`,
      });

      if (category === "wine") set({ wine: response.data.data });
      if (category === "beer") set({ beer: response.data.data });
      if (category === "spirits") set({ spirits: response.data.data });
    } catch (error) {
      useAppStore.setState({
        errors: {
          errorName: error.errorName,
          message: error.message,
          errorCode: error.errorCode,
        },
        success: false,
        product: false,
      });
    }
  },

  /* 
  POST --->
  Removed one Element from car information which to remove 
  is in Id 
    */
  removeFromToCart: async (id) => {
    try {
      const response = await sendRequest({
        url: `${API_URL_CART}remove-one/${id}`,
        method: "POST",
      });

      const cart = response.data.data;
      set({ cart: { products: cart } });
      useAppStore.setState({
        success: true,
      });
    } catch (error) {
      useAppStore.setState({
        errors: {
          errorName: error.errorName,
          message: error.message,
          errorCode: error.errorCode,
        },
        success: false,
      });
    }
  },

  /* 
  GET --->
  gets all Products which are saved in cart 
  */
  showCart: async () => {
    try {
      const response = await sendRequest({
        url: `${API_URL_CART}`,
      });
      const { cart } = response.data.data;
      const { totalPrice } = response.data.data;
      const { totalQty } = response.data.data;

      set({ cart: { products: cart, totalPrice, totalQty } });
      useAppStore.setState({
        success: true,
      });
    } catch (error) {
      useAppStore.setState({
        errors: {
          errorName: error.errorName,
          message: error.message,
          errorCode: error.errorCode,
        },
        success: false,
      });
    }
  },

  /* 
  POST --->
  Makes a Post request to add Prodouct
  */
  addProduct: async (data) => {
    try {
      const response = await sendRequest({
        url: `${API_URL_ADMIN}add-product`,
        data,
        method: "post",
      });

      if (response.status !== 201) {
        return "ERROR";
      }

      useAppStore.setState({
        success: true,
      });
    } catch (error) {
      useAppStore.setState({
        errors: {
          errorName: error.errorName,
          message: error.message,
          errorCode: error.errorCode,
        },
        success: false,
      });
    }
  },

  /* 
  POST --->

  Updates Product Amount in Cart
  Adds Product to Cart
  Bases oon Data ( Action it will deice shoudl it be Updated added or 
  decreased Amounr)
  */
  updateCart: async (id, action) => {
    try {
      const response = await sendRequest({
        url: `${API_URL_CART}update-cart/${id}`,
        data: { action },
        method: "POST",
      });

      const { cart } = response.data.data;
      const { totalPrice } = response.data.data;
      const { totalQty } = response.data.data;

      set({ cart: { products: cart, totalPrice, totalQty } });

      useAppStore.setState({
        success: true,
      });
    } catch (error) {
      useAppStore.setState({
        errors: {
          errorName: error.errorNameName,
          message: error.message,
          errorCode: error.errorCode,
        },
        success: false,
      });
    }
  },

  /* 
  DELETE --->
  Deletes a Single Product based on given ID
  */

  deleteProduct: async (id) => {
    try {
      const response = await sendRequest({
        url: `${API_URL_ADMIN}products/${id}`,
        method: "delete",
      });

      if (response.status !== 200) {
        return "ERROR";
      }
      get().getProducts();

      useAppStore.setState({
        success: true,
      });
    } catch (error) {
      useAppStore.setState({
        errors: {
          errorName: error.errorName,
          message: error.message,
          errorCode: error.errorCode,
        },
        success: false,
      });
    }
  },

  /* 
  PUT --->
  Edits one Single Poduct
  */
  editProduct: async (id, data) => {
    try {
      const response = await sendRequest({
        url: `${API_URL_ADMIN}products/${id}`,
        data,
        method: "PUT",
      });

      if (response.status !== 200) {
        return "ERROR";
      }
      useAppStore.setState({
        success: true,
      });
    } catch (error) {
      useAppStore.setState({
        errors: {
          errorName: error.errorName,
          message: error.message,
          errorCode: error.errorCode,
        },
        success: false,
      });
    }
  },
  /* 
POST --->
Creates Order out of Cart and makes it Empty at the end of the function
*/
  creatOrder: async (data) => {
    try {
      const response = await sendRequest({
        url: `${API_URL_CART}order`,
        data,
        method: "POST",
      });

      if (response.status !== 200) {
        return "ERROR";
      }
      set({ cart: { products: [], totalPrice: 0, totalQuantity: 0 } });
    } catch (error) {
      useAppStore.setState({
        errors: {
          errorName: error.errorName,
          message: error.message,
          errorCode: error.errorCode,
        },
        success: false,
      });
    }
  },
  clearCart: async () => {
    try {
      await sendRequest({
        url: `${API_URL_CART}remove-all`,
        method: "DELETE",
      });

      set({
        cart: {
          products: [],
          totalPrice: 0,
          totalQty: 0,
        },
      });
    } catch (error) {
      useAppStore.setState({
        errors: {
          errorName: error.errorName,
          message: error.message,
          errorCode: error.errorCode,
        },
        success: false,
      });
    }
  },
});

const useShopStore = create(store);
export default useShopStore;
